import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import "./assets/css/singlepage.css";
import "react-toastify/dist/ReactToastify.css";
import "./Responsive.css";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Header from "./components/Header";
import MyComponent from "./components/MyComponent";
import Profile from "./pages/Profile";
import PrivateRoute from "./components/PrivateRoute";
import CreateListing from "./pages/CreateListing";
import UpdateListing from "./pages/UpdateListing";
import PropertyDetail from "./pages/PropertyDetail";
import Footer from "./components/Footer";
import DevloperProjetcs from "./pages/DevloperProjetcs";
import Propertiesbyregion from "./pages/Propertiesbyregion";
import ScrollToTop from "./components/ScrollToTop";
import Leads from "./pages/Leads";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Disclaimer from "./pages/Disclaimer";
import PageNotFound from "./pages/PageNotFound";
import PropertiesOrder from "./pages/PropertiesOrder";
import PuneHome from "./pages/PuneHome";
import PunePropertiesbyregion from "./pages/PunePropertiesbyregion";
import Thankyou from "./pages/Thankyou";
import SeoPropertiesByRegionGoregaon from "./pages/SeoPropertiesByRegionGoregaon";
import SeoPropertiesByRegionMalad from "./pages/SeoPropertiesByRegionMalad";
import SeoPropertiesByRegionMulund from "./pages/SeoPropertiesByRegionMulund";
import SeoPropertiesByRegionVikroli from "./pages/SeoPropertiesByRegionVikroli";
import SeoPropertiesByRegionWorli from "./pages/SeoPropertiesByRegionWorli";
import SeoPropertiesByRegionDadar from "./pages/SeoPropertiesByRegionDadar";
import SeoPropertiesByRegionNerul from "./pages/SeoPropertiesByRegionNerul";
import SeoPropertiesByRegionKharghar from "./pages/SeoPropertiesByRegionKharghar";
import SeoPropertiesByRegionTaloja from "./pages/SeoPropertiesByRegionTaloja";
import SeoPropertiesByRegionPanvel from "./pages/SeoPropertiesByRegionPanvel";
import SeoPropertiesByRegionKalyan from "./pages/SeoPropertiesByRegionKalyan";
import SeoPropertiesByRegionDombivli from "./pages/SeoPropertiesByRegionDombivli";
import SeoPropertiesByRegionShahad from "./pages/SeoPropertiesByRegionShahad";
import SeoPropertiesByRegionNeral from "./pages/SeoPropertiesByRegionNeral";
import SeoPropertiesByRegionPalghar from "./pages/SeoPropertiesByRegionPalghar";
import SeoPropertiesByRegionVasai from "./pages/SeoPropertiesByRegionVasai";
import SeoPropertiesByRegionVirar from "./pages/SeoPropertiesByRegionVirar";
import SeoPropertiesByRegionNaigoan from "./pages/SeoPropertiesByRegionNaigoan";
import SeoPropertiesByRegionBoisar from "./pages/SeoPropertiesByRegionBoisar";
import SeoPropertiesByRegionChembur from "./pages/SeoPropertiesByRegionChembur";
import SeoPropertiesByRegionWadala from "./pages/SeoPropertiesByRegionWadala";
import SeoPropertiesByRegionThane from "./pages/SeoPropertiesByRegionThane";
import SeoPropertiesByRegionChinchwad from "./pages/SeoPropertiesByRegionChinchwad";
import SeoPropertiesByRegionTitwala from "./pages/SeoPropertiesByRegionTitwala";
import SeoPropertiesByRegionBhandhup from "./pages/SeoPropertiesByRegionBhandhup";
import ForgotPassowrd from "./pages/ForgotPassowrd";
import PlotsCreate from "./pages/PlotsCreate";
import EmiCalculator from "./pages/EmiCalculator";
import PlotsUpdate from "./pages/PlotsUpdate";
import Plot from "./pages/Plot";
import PlotDetail from "./pages/PlotDetail";
import AllPlots from "./pages/AllPlots";
import AllBlogs from "./pages/AllBlogs";
import CommercialPropertyDetail from "./pages/CommercialPropertyDetail";
import PunePropertyDetail from "./pages/PunePropertyDetail";
import CommercialPropertiesbyregion from "./pages/CommercialPropertiesbyregion";
import PuneDevloperProjetcs from "./pages/PuneDevloperProjetcs";
import PuneCommercialPropertiesbyregion from "./pages/PuneCommercialPropertiesbyregion";
import SeoDashboard from "./pages/SeoDashboard";

import PlotsDeveloperProjects from "./pages/PlotsDeveloperProjects";
import CompareProperty from "./pages/CompareProperty";
import BlogUpload from "./pages/BlogUpload";
import BlogPage from "./pages/BlogPage";
import SeoLinks from "./components/SeoLinks";
import SinglePage from "./pages/SinglePage";
import CreateSinglePage from "./pages/CreateSinglePage";

function App() {
  return (
    <>
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pune" element={<PuneHome />} />
            <Route path="/plot" element={<Plot />} />
            <Route path="/emi-calculator" element={<EmiCalculator />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="plot/allplots/:subregionname" element={<AllPlots />} />
            <Route path="/compare" element={<CompareProperty />} />
            <Route path="/blogs" element={<AllBlogs />} />
            <Route path="/blog-post/:slug" element={<BlogPage />} />

            <Route
              path="property-detail/:slugname"
              element={<PropertyDetail />}
            />
            <Route path="/locations" element={<SeoLinks />} />
            <Route
              path="/pune/property-detail/:slugname"
              element={<PunePropertyDetail />}
            />
            <Route
              path="/plot/property-detail/:slugname"
              element={<PlotDetail />}
            />
            <Route
              path="/commercial/property-detail/:slugname"
              element={<CommercialPropertyDetail />}
            />
            <Route
              path="propertiesbyregion/:subregionname"
              element={<Propertiesbyregion />}
            />
            <Route
              path="commercialproperties/:subregionname"
              element={<CommercialPropertiesbyregion />}
            />
            <Route
              path="pune/commercialproperties/:subregionname"
              element={<PuneCommercialPropertiesbyregion />}
            />
            <Route
              path="/pune/propertiesbyregion/:subregionname"
              element={<PunePropertiesbyregion />}
            />
            <Route path="projects/:devname" element={<DevloperProjetcs />} />
            <Route
              path="pune/projects/:devname"
              element={<PuneDevloperProjetcs />}
            />
            <Route
              path="plot/projects/:devname"
              element={<PlotsDeveloperProjects />}
            />
            <Route
              path="plot/projects/:devname"
              element={<DevloperProjetcs />}
            />
            <Route path="/thank-you" element={<Thankyou />} />

            <Route
              path="/property-in-goregaon"
              element={<SeoPropertiesByRegionGoregaon />}
            />
            <Route
              path="/property-in-malad"
              element={<SeoPropertiesByRegionMalad />}
            />
            <Route
              path="/property-in-mulund"
              element={<SeoPropertiesByRegionMulund />}
            />
            <Route
              path="/property-in-vikroli"
              element={<SeoPropertiesByRegionVikroli />}
            />
            <Route
              path="/property-in-worli"
              element={<SeoPropertiesByRegionWorli />}
            />
            <Route
              path="/property-in-dadar"
              element={<SeoPropertiesByRegionDadar />}
            />
            <Route
              path="/propertiesbyregion/Airoli-Ghansoli"
              element={<Propertiesbyregion />}
            />
            <Route
              path="/property-in-nerul"
              element={<SeoPropertiesByRegionNerul />}
            />
            <Route
              path="/property-in-kharghar"
              element={<SeoPropertiesByRegionKharghar />}
            />
            <Route
              path="/property-in-taloja"
              element={<SeoPropertiesByRegionTaloja />}
            />
            <Route
              path="/property-in-panvel"
              element={<SeoPropertiesByRegionPanvel />}
            />
            <Route
              path="/property-in-kalyan"
              element={<SeoPropertiesByRegionKalyan />}
            />
            <Route
              path="/property-in-dombivli"
              element={<SeoPropertiesByRegionDombivli />}
            />
            <Route
              path="/property-in-shahad"
              element={<SeoPropertiesByRegionShahad />}
            />

            <Route
              path="/property-in-neral"
              element={<SeoPropertiesByRegionNeral />}
            />
            <Route
              path="/property-in-palghar"
              element={<SeoPropertiesByRegionPalghar />}
            />
            <Route
              path="/property-in-vasai"
              element={<SeoPropertiesByRegionVasai />}
            />
            <Route
              path="/property-in-virar"
              element={<SeoPropertiesByRegionVirar />}
            />
            <Route
              path="/property-in-naigoan"
              element={<SeoPropertiesByRegionNaigoan />}
            />
            <Route
              path="/property-in-boisar"
              element={<SeoPropertiesByRegionBoisar />}
            />
            <Route
              path="/property-in-chembur"
              element={<SeoPropertiesByRegionChembur />}
            />
            <Route
              path="/property-in-wadala"
              element={<SeoPropertiesByRegionWadala />}
            />
            <Route
              path="/property-in-thane"
              element={<SeoPropertiesByRegionThane />}
            />
            <Route
              path="/property-in-chinchwad"
              element={<SeoPropertiesByRegionChinchwad />}
            />

            <Route
              path="/flat-in-titwala"
              element={<SeoPropertiesByRegionTitwala />}
            />
            <Route
              path="/flat-in-kalyan-east"
              element={<SeoPropertiesByRegionKalyan />}
            />
            <Route
              path="/flat-in-kalyan-west"
              element={<SeoPropertiesByRegionKalyan />}
            />
            <Route
              path="/flat-in-shahad-east"
              element={<SeoPropertiesByRegionShahad />}
            />
            <Route
              path="/flat-in-dombivli-east"
              element={<SeoPropertiesByRegionDombivli />}
            />
            <Route
              path="/flat-in-shilphata"
              element={<SeoPropertiesByRegionDombivli />}
            />
            <Route
              path="/flat-in-thakurli"
              element={<SeoPropertiesByRegionDombivli />}
            />
            <Route
              path="/flat-in-sonarpada"
              element={<SeoPropertiesByRegionDombivli />}
            />
            <Route
              path="/flat-in-mulund-east"
              element={<SeoPropertiesByRegionMulund />}
            />
            <Route
              path="/flat-in-taloja"
              element={<SeoPropertiesByRegionTaloja />}
            />
            <Route
              path="/flat-in-panvel"
              element={<SeoPropertiesByRegionPanvel />}
            />
            <Route
              path="/flat-in-bhandup-west"
              element={<SeoPropertiesByRegionBhandhup />}
            />
            <Route
              path="/flat-in-vikhroli-east"
              element={<SeoPropertiesByRegionVikroli />}
            />
            <Route
              path="/flat-in-vasai-east"
              element={<SeoPropertiesByRegionVasai />}
            />
            <Route
              path="/flat-in-virar-west"
              element={<SeoPropertiesByRegionVirar />}
            />
            <Route
              path="/flat-in-nalasopara-west"
              element={<SeoPropertiesByRegionVirar />}
            />
            <Route element={<PrivateRoute />}>
              <Route path="/profile" element={<Profile />} />
              <Route path="/seo" element={<SeoDashboard />} />
              <Route path="/forgotpass" element={<ForgotPassowrd />} />
              <Route path="/create-listing" element={<CreateListing />} />
              <Route
                path="/create-single-listing"
                element={<CreateSinglePage />}
              />
              <Route path="/create-plot-listing" element={<PlotsCreate />} />
              <Route path="/properties-order" element={<PropertiesOrder />} />
              <Route
                path="/update-listing/:listingId"
                element={<UpdateListing />}
              />
              <Route
                path="/update-plot-listing/:listingId"
                element={<PlotsUpdate />}
              />
              <Route path="/leads" element={<Leads />} />
              <Route path="/blogupload" element={<BlogUpload />} />
            </Route>
            <Route path="/test" element={<MyComponent />} />
            <Route path="/testpage" element={<SinglePage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}

export default App;
